import { render, staticRenderFns } from "./ArtistUpload.vue?vue&type=template&id=6d345d7d&scoped=true&"
import script from "./ArtistUpload.vue?vue&type=script&lang=ts&"
export * from "./ArtistUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ArtistUpload.vue?vue&type=style&index=0&id=6d345d7d&prod&lang=scss&"
import style1 from "./ArtistUpload.vue?vue&type=style&index=1&id=6d345d7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d345d7d",
  null
  
)

export default component.exports